/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonImportResultOfstringAndJsonEventPartyImport,
    JsonImportResultOfstringAndJsonEventPartyImportFromJSON,
    JsonImportResultOfstringAndJsonEventPartyImportFromJSONTyped,
    JsonImportResultOfstringAndJsonEventPartyImportToJSON,
} from './JsonImportResultOfstringAndJsonEventPartyImport';

/**
 * 
 * @export
 * @interface ApiResultOfJsonImportResultOfstringAndJsonEventPartyImport
 */
export interface ApiResultOfJsonImportResultOfstringAndJsonEventPartyImport {
    /**
     * 
     * @type {JsonImportResultOfstringAndJsonEventPartyImport}
     * @memberof ApiResultOfJsonImportResultOfstringAndJsonEventPartyImport
     */
    data?: JsonImportResultOfstringAndJsonEventPartyImport;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonImportResultOfstringAndJsonEventPartyImport
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfJsonImportResultOfstringAndJsonEventPartyImport
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonImportResultOfstringAndJsonEventPartyImport
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonImportResultOfstringAndJsonEventPartyImport
     */
    result?: ApiResultOfJsonImportResultOfstringAndJsonEventPartyImportResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfJsonImportResultOfstringAndJsonEventPartyImportResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfJsonImportResultOfstringAndJsonEventPartyImportFromJSON(json: any): ApiResultOfJsonImportResultOfstringAndJsonEventPartyImport {
    return ApiResultOfJsonImportResultOfstringAndJsonEventPartyImportFromJSONTyped(json, false);
}

export function ApiResultOfJsonImportResultOfstringAndJsonEventPartyImportFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfJsonImportResultOfstringAndJsonEventPartyImport {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : JsonImportResultOfstringAndJsonEventPartyImportFromJSON(json['data']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfJsonImportResultOfstringAndJsonEventPartyImportToJSON(value?: ApiResultOfJsonImportResultOfstringAndJsonEventPartyImport | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': JsonImportResultOfstringAndJsonEventPartyImportToJSON(value.data),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

